<div class="progress-dots">
	@for (index of dotsArray(); track index) {
		<div
			class="progress-dot"
			[class.active]="currentIndex() === index"
			[class.clickable]="clickable()"
			(click)="onDotClick(index)"
			[attr.role]="clickable() ? 'button' : null"
			[attr.tabindex]="clickable() ? 0 : null"
		></div>
	}
</div>
